import { PanelLeftIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { useSidebar } from "@/components/ui/sidebar";
import { EsiSymbol } from "../../brand/EsiMark.tsx";

/**
 * The sidebar's collapse and expand control. Collapsed, its resting face is the ESI symbol (small
 * cut, decorative) and hovering or keyboard focus reveals the panel icon in the same place
 * (decision D3); `mark={false}` (a tenant logo in use) keeps the panel icon only. Its accessible
 * name is always the toggle's label.
 */
export function RailTrigger({ mark }: { mark: boolean }) {
  const { t } = useTranslation();
  const { state, toggleSidebar } = useSidebar();
  const resting = mark && state === "collapsed";
  return (
    <Button
      data-sidebar="trigger"
      data-slot="sidebar-trigger"
      variant="ghost"
      size="icon"
      className="group/trigger size-7 text-fg-muted hover:text-fg"
      onClick={toggleSidebar}
    >
      {resting ? (
        <EsiSymbol
          size={20}
          decorative
          className="size-5 group-hover/trigger:hidden group-focus-visible/trigger:hidden"
        />
      ) : null}
      <PanelLeftIcon
        aria-hidden="true"
        className={
          resting ? "hidden group-hover/trigger:block group-focus-visible/trigger:block" : undefined
        }
      />
      <span className="sr-only">{t("nav.toggleSidebar")}</span>
    </Button>
  );
}
